require("./js//EmployeeGridPanel.js");
require("./js//Models.js");
require("./js//ExceptionHandler.js");
require("./js//HumanResources.js");
require("./js//ContractEditDialog.js");
require("./js//EmployeeEditDialog.js");
require("./js//DatePicker.js");
require("./js//FreeDayGridPanel.js");
require("./js//FreeTimeEditDialog.js");
require("./js//VacationEditDialog.js");
require("./js//SicknessEditDialog.js");
require("./js//ContractDetailsPanel.js");
require("./js//ContractGridPanel.js");
require("./js//CostCenterGridPanel.js");
require("./js//FreeTimeEmployeeFilter.js");
require("./js//AccountGridPanel.js");
require("./js//FreeTimeGridPanel.js");
require("./js//ExtraFreeTimeEditDialog.js");
require("./js//ExtraFreeTimeGridPanel.js");
require("./js//AccountEditDialog.js");
require("./js//AdminPanel.js");
require("./js//WorkingTimeEditDialog.js");
require("./js//BreakGridPanel.js");
require("./css//HumanResources.css");
